import React from 'react';

import { ServerMessageHandler } from '@swf/notification';

import Prompt from '../../Prompt/Prompt';

import {
  TXTWCL_Deposit_another_way,
  TXTWCL_Payment_method_unavailable
} from './NotAvailable.messages.json';

interface Props {
  defaultMessage: string;
  onClose(): void;
}

const NotAvailable: React.FC<Props> = ({ defaultMessage, onClose }) => (
  <Prompt
    onClose={onClose}
    variant="warning"
    title={{
      translation: TXTWCL_Payment_method_unavailable
    }}
    primaryButton={{
      translation: TXTWCL_Deposit_another_way
    }}
    alert={<ServerMessageHandler message={defaultMessage} />}
  />
);

export default NotAvailable;
